// extracted by mini-css-extract-plugin
export var container = "_hr-0";
export var dotAnimation = "_hr-2";
export var dotsLoading = "_hr-1";